import {gql, useQuery} from "@apollo/client";
import {DSP_FIELDS, DspType} from "../types/DspType";
import { useEffect, useState } from "react";

export const GET_DSPS_BY_HUB_ID_FOR_WMS = gql`
  query GetDspsByHubIdForWms($hubId: Long!) {
    dspList: getDspsByHubIdForWms(hubId: $hubId) {
      ...DspFields
    }
  }
  ${DSP_FIELDS}
`;

export interface GetDspsByHubIdForWmsResponse {
    dspList: DspType[];
}

export interface GetDspsByHubIdForWmsVariables {
    hubId: number;
}

export const useDspsByHubIdForWms = (hubId?: number) => {
    const [dsps, setDsps] = useState<DspType[]>([]);
    const {data, loading, error, refetch} = useQuery<GetDspsByHubIdForWmsResponse, GetDspsByHubIdForWmsVariables>(
        GET_DSPS_BY_HUB_ID_FOR_WMS,
        {
            variables: { hubId: hubId! },
            skip: !hubId,
        }
    );

    useEffect(() => {
        if (data) {
            setDsps(data.dspList.map(dsp => ({...dsp, warehouseIds: dsp.warehouses.map(warehouse => Number(warehouse.id))})));
        }
    }, [data]);

    return {
        dsps,
        loading,
        refetch,
        error
    };
};
